import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { fileUrl } from "@/components/PersonalEntryDialog";
import { ImageSquare, Trash, UploadSimple } from "@phosphor-icons/react";
import { toast } from "sonner";

export function LogoUploadCard() {
  const { user } = useAuth();
  const [logoId, setLogoId] = useState(null);
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  useEffect(() => { api.get("/company/label").then((r) => setLogoId(r.data.logo_file_id)).catch(() => {}); }, []);
  if (!["company", "autonomo"].includes(user?.role)) return null;

  const upload = async (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    if (!["image/png", "image/jpeg"].includes(f.type)) return toast.error("Envie uma imagem PNG ou JPG");
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", f);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await api.put("/company/logo", { file_id: data.id });
      setLogoId(data.id); toast.success("Logomarca salva");
    } catch { toast.error("Falha ao enviar a logomarca"); } finally { setBusy(false); e.target.value = ""; }
  };
  const remove = async () => { await api.put("/company/logo", { file_id: null }); setLogoId(null); toast.success("Logomarca removida"); };

  return (
    <Card data-testid="logo-upload-card">
      <CardHeader><CardTitle className="text-lg flex items-center gap-2"><ImageSquare size={22} weight="duotone" className="text-blue-600" /> Logomarca da empresa</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-slate-600">Aparece no topo do Acerto Final, do Recibo e dos relatórios em PDF.</p>
        <div className="flex items-center gap-4 flex-wrap">
          <div className="h-20 w-40 rounded-lg border-2 border-dashed flex items-center justify-center bg-white overflow-hidden">
            {logoId ? <img src={fileUrl(logoId)} alt="Logomarca" className="max-h-full max-w-full object-contain" data-testid="logo-preview" /> : <span className="text-xs text-slate-400">Sem logomarca</span>}
          </div>
          <div className="flex gap-2">
            <Button onClick={() => input.current?.click()} disabled={busy} data-testid="btn-upload-logo" className="bg-blue-600 hover:bg-blue-700 text-white gap-1.5"><UploadSimple size={16} /> {busy ? "Enviando..." : logoId ? "Trocar" : "Enviar logomarca"}</Button>
            {logoId && <Button variant="outline" onClick={remove} data-testid="btn-remove-logo"><Trash size={16} className="text-red-600" /></Button>}
          </div>
          <input ref={input} type="file" accept="image/png,image/jpeg" hidden onChange={upload} data-testid="logo-file-input" />
        </div>
      </CardContent>
    </Card>
  );
}
